import styled from "styled-components";
import "./App.css";
import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import queryString from "query-string";
import axios from "axios";

function updateBackend(url, key, data) {
  return fetch(url, {
    method: "PUT",
    headers: new Headers({
      Authorization: "Bearer " + key,
      Accept: "application/json",
      "Content-Type": "application/json",
    }),

    body: JSON.stringify(data),
  });
}
function getBackend(url, key) {
  return fetch(url, {
    method: "get",
    headers: new Headers({
      Authorization: "Bearer " + key,
    }),
  });
}

function App() {
  const location = useLocation();
  const history = useHistory();
  const apiUrl = 'https://reports-api.tatweertransit.com';

  const [docData, setDocData] = useState({
    login: false,
    valid: false,
  });

  const [showPDF, setShowPDF] = useState(false);
  const [processStatus, setProcessStatus] = useState(false);

  const handleNumChange = event => {
    const limit = 10;
    setnId(event.target.value.slice(0, limit));
  };

  const [invoiceId, setinvoiceId] = useState("");
  const [nId, setnId] = useState("");
  // useEffect(() => {
  //   // Using an IIFE
  //   (async function anyNameFunction() {
  //     const parsed = queryString.parse(location.search);
  //     if (parsed.invoiceId && parsed.nid) {
  //       setinvoiceId(parsed.invoiceId);
  //       setnId(parsed.nid);

  //       axios
  //         .get(
  //           `${apiUrl}/Noor/validate?invoiceId=${parsed.invoiceId}&nid=${parsed.nid}`
  //         )
  //         .then((data) => {
  //           console.log(data);
  //           setDocData(data.data);
  //           // setlogin(true);
  //           // setvalid(true);
  //         });
  //     }
  //   })();
  // }, []);


  const [validateForm, setValidateForm] = useState();
  const [isValid, setIsValid] = useState(false);
  const [loading, setLoading] = useState(false);

  const ValiditeSubmit = () => {
    setIsValid(false);
    if (nId && invoiceId) {
      setValidateForm('');
      setLoading(true);
      axios
        .get(
          `${apiUrl}/Noor/validate?invoiceId=${invoiceId}&nid=${nId}`
        )
        .then((data) => {
          setLoading(false);
          if (data.status == 200) {
            console.log(data.status, data.data);
            setValidateForm(data.data.message);
            setIsValid(data.data.valid);

          } else {
            setValidateForm('خطآ ، فضلا المحاولة في وقت لاحق');
          }

          // setDocData(data.data);
          // setlogin(true);
          // setvalid(true);
        });
    } else {
      if (!invoiceId)
        setValidateForm('فضلا ادخال رقم الفاتورة');
      else if (!nId)
        setValidateForm('فضلا ادخال سجل الطالب');

    }
  }
  return (
    <div className="App">
      <Header>
        <Logo src="/images/logo.svg" />
      </Header>
      <HeaderContainer>
        <span dir="rtl">
          طلب إلغاء التسجيل في خدمة النقل المدرسي واسترداد الرسوم￼
        </span>
      </HeaderContainer>

      <BodyContainer>
        <h5 dir="rtl">
          الخدمة تتيح لولي الأمر رفع طلب إلغاء التسجيل في خدمة النقل المدرسي واسترداد المبلغ المدفوع عبر إدخال رقم الفاتورة من نظام نور ورقم هوية الطالب
        </h5>

        <FormGroup>

          {/* <p style={{ "color": {isValid ? 'red' : 'green'} }}>{validateForm}</p> */}
          <p style={{ color: isValid ? 'green' : 'red' }}>{validateForm}</p>

          {loading &&
            <p> جاري التحقق </p>
          }
          <Label htmlFor="label">رقم الفاتورة</Label>
          <Input
            id="label"
            value={invoiceId}
            onChange={(e) => {
              setinvoiceId(e.target.value);
            }}
          />
        </FormGroup>
        <FormGroup>
          <Label>سجل الطالب </Label>
          <Input
            id="nId"
            type="number"
            value={nId}
            onChange={(e) => {
              setnId(e.target.value.slice(0, 10));
            }}
          />
        </FormGroup>
        <Message></Message>

        <Button
          style={{ 'width': '150px' }}
          disabled={loading}
          onClick={() => ValiditeSubmit()}
        >
          {!loading ? " تـأكـيـد " : " ..... جاري التحقق "}
        </Button>
      </BodyContainer>

      {/* {docData?.login && docData?.valid && 1 == 2 && (
        <BodyContainer>
          <Title>{docData.title}</Title>
          <h5>{docData.sub_title}</h5>

          {!showPDF && (
            <>
              {" "}
              <ResultContainer valid={true}>
                <h3 dir={"rtl"}>


                  عزيزي ولي أمر الطالب رقم هوية  {nId}– ورقم فاتورة {invoiceId} للتأكيد على رفع طلب الإلغاء اضغط الزر بالأسفل
                </h3>

              </ResultContainer>
              <Button
                onClick={() => {
                  axios
                    .get(
                      `${apiUrl}/Noor/process?invoiceId=${invoiceId}&nid=${nId}`
                    )
                    .then((data) => {
                      setShowPDF(true);

                      console.log('datadata', data.data.sucess)
                      setProcessStatus(data.data.sucess)
                      // setlogin(true);
                      // setvalid(true);
                    });
                }}
              >
                تأكيد B
              </Button>
            </>
          )}
          {showPDF && (<>
            {processStatus ? <ProcessSuccessContainer>تم رفع الطلب بنجاح وسيتم التعامل معه خلال الفترة القادمة</ProcessSuccessContainer> :
              <ProcessFailedContainer>فشل رفع طلب الإلغاء للإدارة المعنية بنجاح</ProcessFailedContainer>}
          </>)}
        </BodyContainer>
      )}

      {docData?.login && !docData?.valid && 1 == 2 && (
        <BodyContainer>
          <h5>
            الخدمة تتيح لولي الأمر رفع طلب إلغاء التسجيل في خدمة النقل المدرسي واسترداد المبلغ المدفوع عبر إدخال رقم الفاتورة من نظام نور ورقم هوية الطالب

          </h5>

          <ResultContainer valid={false}>
            <h3 dir={"rtl"}>
              لم يتم رفع طلب الإلغاء لأحد الأسباب التالية:
            </h3>
            <ul>
              <li>تم رفع طلب سابق وجاري التعامل معه</li>
              <li>رقم الفاتورة أو رقم الهوية غير صحيح</li>
            </ul>
            <br></br>
            في حالة استمرار رفض رفع الطلب نأمل التواصل على الرقم المجاني الموضح أدناه

          </ResultContainer>
        </BodyContainer>
      )} */}

      <Footer>
        <InquiriesContainer>
          <h5>الشكاوى والاستفسارات</h5>
          <a href="mailto:cs@tatweertransit.com">
            cs@tatweertransit.com
          </a>
          <a href="tel:8001231000">8001231000</a>
        </InquiriesContainer>
        <div>شركة تطوير لخدمات النقل "رافد" © 2022</div>
      </Footer>
    </div>
  );
}

const Title = styled.h1`
  color: rgb(29, 45, 80);
`;
const InquiriesContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const Footer = styled.footer`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  bottom: 0;
  background: #eaeaea;
  align-items: center;
`;

const Button = styled.button`
  margin: 30px;
  border: navajowhite;
  background-color: rgb(225, 82, 62);
  padding: 9px;
  color: #ffffff;
  font-weight: bold;
  font-size: 1.3em;
  border-radius: 999px;
  cursor: pointer;
`;
const BodyContainer = styled.div`
  margin: 40px;
  flex: 1;
`;
const Header = styled.header`
  display: flex;
  justify-content: flex-end;
  padding: 10px;
`;

const Logo = styled.img`
  width: 120px;
`;
const HeaderContainer = styled.div`
  background-color: rgb(29, 45, 80);
  padding: 6px;
  color: #ffffff;
`;
const ResultContainer = styled.div`
  background: ${(props) => (props.valid ? "teal" : "red")};
  color: #ffffff;
  padding: 10px;
  margin: 20px 0px;
`;

const FormGroup = styled.div`
  color: palevioletred;
  display: block;
  width: 300px;
  margin: 5px auto;
`;

const Label = styled.label`
  margin-bottom: 0.5em;
  color: rgb(29, 45, 80);
  display: block;
`;

const Input = styled.input`
  padding: 0.5em;
  color: palevioletred;
  background-color: #fcfcfd;
  border-style: solid;
  border-color: #e5e6e6;
  border-radius: 2px;
  width: 100%;
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.8);
`;

const Message = styled.label`
  margin-bottom: 0.5em;
  color: palevioletred;
  display: block;
`;

const StyledIFrame = styled.iframe`
  height: 100%;
  width: 100%;
`;
export default App;
const ProcessSuccessContainer = styled.div`
  text-align: center;
  background: #287bc2;
  color: #fff;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const ProcessFailedContainer = styled.div`
  text-align: center;
  background: #c2284c;
  color: #fff;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const CloseButton = styled.button`
  background: #bb1e49;
  border: none;
  color: #fff;
  margin: 10px;
  min-height: 30px;
  min-width: 70px;
  font-weight: bold;
`;
